import { render, staticRenderFns } from "./PopupDeleteData.vue?vue&type=template&id=7420de54"
import script from "./PopupDeleteData.vue?vue&type=script&lang=js"
export * from "./PopupDeleteData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports